import * as types from '../mutation_types';
import router from '@views/home/router';
import axios from 'axios';

const debug = false;
const debugGetWorkstation = debug;

export default {
  getWorkstation({commit, state, dispatch, rootState}, payload) {
    return new Promise((resolve, reject) => {
      dispatch('setLoading', true, {root: true});

      let call;
      if (debugGetWorkstation) {
        call = import('@fixtures/workstation-fixture');
      } else {
        const token = router.app.$context.token;
        call = axios.get(`/api/v1/workstation-detail/${payload.workstation_id}/?date=${payload.date}`, {
          headers: {
            Authorization: `Token ${token}`
          }
        });
      }
      call.then(response => {
        dispatch('workstation/setWorkstation', response.data, {root: true});
        resolve(response.data);
        dispatch('setLoading', false, {root: true});
      }).catch(err => {
        reject(err);
        dispatch('setLoading', false, {root: true});
      });
    });
  },
  setWorkstation({commit}, payload) {
    return new Promise((resolve, reject) => {
      try {
        commit(types.SET_WORKSTATION, payload);
        resolve();
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  },
  setBooking({commit, state, dispatch, rootState}, payload) {
    return new Promise((resolve, reject) => {
      dispatch('setLoading', true, {root: true});

      const token = router.app.$context.token;
      axios.post(`/api/v1/workstation-reservation/`, payload, {
        headers: {
          Authorization: `Token ${token}`
        }
      }).then(response => {
        resolve(response.data);
        dispatch('setLoading', false, {root: true});
      }).catch(err => {
        reject(err);
        dispatch('setLoading', false, {root: true});
      });
    });
  },
  setColleagueBooking({commit, state, dispatch, rootState}, payload) {
    return new Promise((resolve, reject) => {
      dispatch('setLoading', true, {root: true});

      const token = router.app.$context.token;
      axios.post(`/api/v1/colleague-workstation-reservation/`, payload, {
        headers: {
          Authorization: `Token ${token}`
        }
      }).then(response => {
        resolve(response.data);
        dispatch('setLoading', false, {root: true});
      }).catch(err => {
        reject(err);
        dispatch('setLoading', false, {root: true});
      });
    });
  }
};
